import Layout from '@layout/Index'

export const priceBatchForm = [
  {
    path: '/price-batch',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "PriceBatchTable" */ './pages/PriceBatchTable.vue'),
        name: '调价批次',
        meta: {
          title: '调价批次',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "PriceBatchForm" */ './pages/PriceBatchForm.vue'),
        name: '新增调价批次',
        meta: {
          title: '新增调价批次',
        },
      },
      {
        path: 'detail/:priceId',
        component: () => import(/* webpackChunkName: "PriceBatchForm" */ './pages/PriceBatchForm.vue'),
        name: '调价批次详情',
        meta: {
          title: '调价批次详情',
        },
        props: true,
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/price-batch/price-batch.route.js